import React from 'react'

const SkillCard = ({ title = "SKILL NAME", image = "123", linkTo = "#" }) => {
    return (
        <div
            // href={linkTo}
            // target='_blank' 
            // rel='noreferrer' 
            className='initial-opacity-animation dark:bg-cDarkBG2/20 bg-white/20 backdrop-blur border border-white/10 shadow-md rounded-xl sm:rounded-2xl p-4 flex flex-col items-center justify-center space-y-3 w-full sm:h-[120px] h-[100px] cursor-default'>
            <div className='sm:h-[65px] sm:w-[65px] w-[35px] h-[35px] flex justify-center'>
                <img src={image} alt={title} className='w-full h-[40px] object-contain' />
            </div>
            <div className='dark:text-cDarkText text-gray-500 sm:text-lg font-light text-xs'>{title}</div>
        </div>
    )
}

export default SkillCard